/* @flow weak */
import React from 'react';
import { DateTimePicker as ReactDateTimePicker } from 'lib/ReactWidgets';
import DateTimePickerMixin from './mixins/DateTimePickerMixin';
import Glyph from 'components/Glyph.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import { datePopups as popups } from 'react-widgets/lib/util/constants';
import createChainedFunction from 'utils/createChainedFunction';
import cx from 'classnames';
import './styles/DatePickerInput.scss';

const DatePickerInput = React.createClass({
  propTypes: {
    value: React.PropTypes.instanceOf(Date),
    min: React.PropTypes.instanceOf(Date),
    max: React.PropTypes.instanceOf(Date),
    placeholder: React.PropTypes.string,
    className: React.PropTypes.string,
    onChange: React.PropTypes.func,
    onBlur: React.PropTypes.func,
    autofocus: React.PropTypes.bool,
    placement: React.PropTypes.oneOf(['top', 'bottom']),
    disabled: React.PropTypes.bool,
    'data-test': React.PropTypes.string,
  },

  mixins: [
    DateTimePickerMixin, // for this.state.opened and this.props.autofocus
  ],

  statics: {
    propClasses: {
      placement: {
        top: 'DateTimePicker-top',
        bottom: 'DateTimePicker-bottom',
      },
    },
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
      disabled: false,
    };
  },

  onClick(event) {
    if (!this.props.disabled) {
      this.handleClick(event);
    }
  },

  render() {
    const open = this.isOpen() ? popups.CALENDAR : false;
    const { value, min, max, placeholder, className, disabled, onBlur, onChange } = this.props;
    const datePickerClass = cx('DatePickerInput DateTimePicker', className, {
      'is-focused': this.isFocused(),
    });

    const parse = val => {
      const date = new Date(val);
      return date instanceof Date && !isNaN(date.valueOf()) ? date : null;
    };

    return (
      <div
        className={cx(datePickerClass, getPropClassesFromInstance(this), {
          'DatePickerInput-disabled': disabled,
        })}
        onClick={this.onClick}>
        <Glyph
          name="schedule"
          color="eclipse"
        />
        <ReactDateTimePicker
          data-test={this.props['data-test']}
          ref="picker"
          value={value}
          min={min}
          max={max}
          placeholder={placeholder}
          open={open}
          duration={0}
          format="M/d/yyyy"
          finalView="month"
          parse={parse}
          dayFormat={date => ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()]}
          onFocus={this.handleFocus}
          onKeyDown={this.closePopup}
          onBlur={createChainedFunction(this.handleBlur, onBlur)}
          onChange={createChainedFunction(this.handleChange, onChange)}
          onToggle={() => {}}
          className={cx({
            'DatePickerInput-disabled': disabled,
          })}
        />
      </div>
    );
  },
});

export default DatePickerInput;



// WEBPACK FOOTER //
// ./src/components/DatePickerInput.jsx